import request from "@/utils/request";
import requestOL from "@/utils/request-ol";
import themezone from "@/api/themezone";
import config from "@/utils/config";
import requestMA from '@/utils/request-ma';
let baseApi = config.env.VUE_APP_BRAND === 'COTTI' ? '/cotti-capi' : '/teacat-capi'

export function getWechatSign(data) {
  return requestOL({
    url: `${baseApi}/wechat/sign`,
    method: "POST",
    data,
  });
}

export function getAreas() {
  return request({
    url: "/franchise-api/intention/areas",
    method: "GET",
  });
}

export function getSmsCode(data) {
  return request({
    url: "/franchise-api/intention/smsCode",
    method: "POST",
    data,
  });
}

export function addLeads(data) {
  return request({
    url: "/franchise-api/intention/addLeads",
    method: "POST",
    data,
  });
}

export function addLeadsSms(data) {
  return request({
    url: "/franchise-api/intention/addLeadsSms",
    method: "POST",
    data,
  });
}


export function queryExistLeads(data) {
  return request({
    url: "/franchise-api/intention/queryExistLeads",
    method: "POST",
    data,
  });
}

export function getProductDetail(data, version) {
  return request({
    url: "/dj-api/item/itemDetail",
    method: "POST",
    data,
    version,
  });
}

export function checkUpdate(data) {
  return request({
    url: `${baseApi}/ota/checkUpdate`,
    method: "POST",
    data,
  });
}

export function listItemDetail(data) {
  return request({
    url: "/dj-api/item/listItemDetail",
    method: "POST",
    data,
  });
}


export function getOpenid(data) {
  return requestOL({
    url: `${baseApi}/wechat/getOpenid`,
    method: "POST",
    data,
  });
}



export function getCustomerSmsCodeOL(data) {
  return requestOL({
    url: `${baseApi}/customer/smsCode`,
    method: "POST",
    version:'v3',
    data
  });
}


export function getCustomerCheckSmsCodeH5(data) {
  return requestMA({
    url: `${baseApi}/universal/coupon/checkLaunchSmsCodeRewardH5`,
    method: "POST",
    data,
  });
}
export function getCustomerCheckSmsCodeOL(data) {
  return requestOL({
    url: `${baseApi}/customer/checkSmsCode`,
    method: "POST",
    data,
  });
}

export function getCustomerSmsCode(params) {
  return request({
    url: "/dj-api/customer/smsCode",
    method: "GET",
    params,
  });
}


export function getCustomerCheckSmsCode(data) {
  return request({
    url: "/dj-api/customer/checkSmsCode",
    method: "POST",
    data,
  });
}

export function marketingGetH5Activity(data) {
  return requestMA({
    url: `${baseApi}/universal/coupon/getH5Activity`,
    method: "POST",
    data,
  });
}

export function marketingReceiveRewardH5(data) {
  return requestMA({
    url: `${baseApi}/universal/coupon/receiveLaunchRewardH5`,
    method: "POST",
    data,
  });
}

export function marketingShareH5Act(data) {
  return requestMA({
    url: `${baseApi}/universal/coupon/shareH5Act`,
    method: "POST",
    data,
  });
}


export function customerActivityFissionInviterDetail(data) {
  return request({
    url: "/dj-api/customer/activity/fission/inviter/detail",
    method: "POST",
    data,
  });
}

export function customerActivityFissionInvite(data) {
  return request({
    url: "/dj-api/customer/activity/fission/invite",
    method: "POST",
    data,
  });
}


export function customerActivityFissionInviteeDetail(data) {
  return request({
    url: "/dj-api/customer/activity/fission/invitee/detail",
    method: "POST",
    data,
  });
}


export function customerActivityFissionReceiveReward(data) {
  return request({
    url: "/dj-api/customer/activity/fission/receiveReward",
    method: "POST",
    data,
  });
}


export function voucherGetYouzanVoucherNumByMobile(data) {
  return request({
    url: `/dj-api/voucher/getYouzanVoucherNumByMobile`,
    method: "GET",
    params: data
  });
}


export function customerActivityFissionShare(data) {
  return request({
    url: `/dj-api/customer/activity/fission/share`,
    method: "POST",
    data,
  });
}


export function getDownloadBanner(data) {
  return requestMA({
    url: `${baseApi}/customer/position/list`,
    method: "POST",
    data,
  });
}

export function getDownloadBannerCotti(data) {
  return requestMA({
    url: `${baseApi}/customer/position/list`,
    method: "POST",
    data,
  });
}

export function getWeChatScheme(data) {
  return request({
    url: `${baseApi}/config/weChatScheme`,
    method: "POST",
    data,
  });
}

export function getConfigImg(data) {
  return requestMA({
    url: `${baseApi}/customer/position/list`,
    method: "POST",
    data,
  });
}

export function getLandPage(data) {
  return requestOL({
    url: `${baseApi}/customer/position/landPage`,
    method: "POST",
    data,
  });
}

export function assistDefaultSchemeActivity(data) {
  return request({
    url: `${baseApi}/fission/defaultSchemeActivityHelperTaker`,
    method: "POST",
    data,
  });
}

export function getAdvertiseApi(data) {
  return requestMA({
    url: `${baseApi}/customer/position/list`,
    method: "POST",
    data,
  });
}
export function queryActiveByCodeApi(params) {
  return requestOL({
    url: `${baseApi}/launchPlan/launchPlanDetail`,
    method: "POST",
    data:params,
  });
}

export default {
  themezone
}

export function getNearByShop(data) {
  return requestOL({
    url: `${baseApi}/launchPlan/nearByShopList`,
    method: "POST",
    data,
  });
}

export function getCouponRecord(data) {
  return request({
    url: `${baseApi}/launchPlan/getCouponRecord`,
    method: "POST",
    data,
  });
}

export function getUserInfo(data) {
  return request({
    url: `${baseApi}/wechat/getUserInfo`,
    method: "POST",
    data,
  });
}

export function authorizationCheck(data) {
  return requestOL({
    url: `${baseApi}/wechat/authorizationCheck`,
    method: "POST",
    data,
  });
}

export function appCheckUpdate(data) {
  return request({
    url: `${baseApi}/ota/checkUpdate`,
    method: "POST",
    data,
  });
}

